import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

function HomePage() {
  const [questions, setQuestions] = useState([]);
  const [showInstructions, setShowInstructions] = useState(true);

  useEffect(() => {
    fetch(`https://www.cognospring.site/api/list/questions`)
      .then(res => res.json())
      .then(data => setQuestions(data.sort((a, b) => b.likes - a.likes)))
      .catch(console.error);
  }, []);

  if (!questions.length) {
    return <div>Loading questions...</div>;
  }

  return (
    <div className="home-container">
      <h1>海龟汤谜题精选</h1>
      <div className="instructions-container">
        <button
          className="toggle-instructions"
          onClick={() => setShowInstructions(!showInstructions)}
        >
          {showInstructions ? '▲ 收起玩法说明' : '▼ 查看游戏规则'}
        </button>
        {showInstructions && (
          <div className="instructions-content">
            <p>🏮 欢迎来到海龟汤推理游戏！</p>
            <ul>
              <li>谜底可能涉及血腥，灵异元素。未成年人在家长陪同下游玩!!!</li>
              <li>手机端体验更佳哦</li>
              <li>通过提问验证汤面（谜题）和汤底（真相）的关系</li>
              <li>AI裁判只会回答「是」「否」「是也不是」「不重要」四种答案</li>
              <li>认为接近真相时可以点击提交最终提交你认为的结局</li>
              <li>AI会自动评分并给出最终答案</li>
            </ul>
          </div>
        )}
      </div>
      <div className="question-list">
        {questions.map(question => (
          <div key={question.id} className="question-card">
            <div className="question-link">
              <h3>{question.title}</h3>
              <p>{question.content.substring(0, 50)}...</p>
            </div>
            <div className="card-footer">
              <Link 
                to={`/game/${question.id}`}
                className="start-btn"
              >
                🎮 开始游戏
              </Link>
              <button className="like-btn">
                ❤️{question.likes}
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="footer">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">
          桂ICP备2025061767号
        </a>
      </div>
    </div>
  );
}

export default HomePage;
